
/**
 * Date formats we require.
 */
export enum DateFormat {
    YYYY_MM_DD,
    HH_MM_SS
}

export const DateUtils = {
    /**
     * Formats date according to format type.
     *
     * @param {Date} date
     * @param {DateFormat} format
     * @param {number} pad left zero padding (set to 0 to disable)
     * @param {string} sepDate separator for date portions
     * @param {string} sepTime separator for time portions
     * @returns {string}
     */
    format(date: Date, format?: DateFormat, pad = 2, sepDate = '/', sepTime = ':'): string {
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        const hour = date.getHours()
        const minute = date.getMinutes()
        const second = date.getSeconds()
        const HOUR_FORMAT = 24

        if (format === DateFormat.YYYY_MM_DD) {
            return `${year}` +
                `${sepDate}${month.toString().padStart(pad, '0')}` +
                `${sepDate}${day.toString().padStart(pad, '0')}`
        }

        if (format === DateFormat.HH_MM_SS) {
            return `${(+hour % HOUR_FORMAT).toString().padStart(pad, '0')}` +
                `${sepTime}` +
                `${minute.toString().padStart(pad, '0')}` +
                `${sepTime}` +
                `${second.toString().padStart(pad, '0')}`
        }

        // default to native locale
        return date.toLocaleDateString()
    }
}
